import { createSlice } from '@reduxjs/toolkit';
import dayjs from 'dayjs';
import { reHydrateStore } from '../utils/local-storage';

const initialState = {
  order: null,
  id: null,
  step: '',
  orderInfo: null,
  customer: {
    valid: false,
  },
};

const slice = createSlice({
  name: 'booking',
  initialState: reHydrateStore('booking') || initialState,
  reducers: {
    setBooking: (state, { payload }) => ({ ...payload }),
    setBookingOrder: (state, { payload }) => ({
      ...state,
      order: payload,
    }),
    setBookingId: (state, { payload }) => ({
      ...state,
      id: payload,
    }),
    setBookingStep: (state, { payload }) => ({
      ...state,
      step: payload,
    }),
    setOrderInfo: (state, { payload }) => ({
      ...state,
      orderInfo: payload,
    }),
    setStartDate: (state, { payload }) => ({
      ...state,
      startDate: dayjs().format(),
    }),
    setStartBookingDate: (state, { payload }) => ({
      ...state,
      startBookingDate: dayjs().format(),
    }),
    setCustomer: (state, { payload }) => ({
      ...state,
      customer: payload,
    }),
    restore: () => initialState,
  },
});

export const {
  setBooking,
  setBookingOrder,
  setBookingId,
  setBookingStep,
  setOrderInfo,
  setStartDate,
  setStartBookingDate,
  setCustomer,
  restore,
} = slice.actions;

export default slice.reducer;
